import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { OPERATIONS_COMPLAINTS_SERIES } from "../constants";
import { OperationsMetricChartWidget } from "../OperationsMetricChartWidget";
import type { OperationsComplaintsChartData } from "../types";

interface OperationsComplaintsWidgetProps {
  chart: OperationsComplaintsChartData;
  yAxisMax?: number;
  onExport?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
  className?: string;
}

export const OperationsComplaintsWidget: React.FC<
  OperationsComplaintsWidgetProps
> = ({ chart, yAxisMax, onExport, exportDisabled, className }) => {
  const { t } = useTranslation();

  const series = useMemo(
    () =>
      OPERATIONS_COMPLAINTS_SERIES.map((item) => ({
        ...item,
        label: t("analytics.operations.complaints.series", item.label),
      })),
    [t],
  );

  return (
    <OperationsMetricChartWidget
      title={t("analytics.operations.complaints", "Complaints")}
      data={chart.data}
      series={series}
      yAxisMax={yAxisMax}
      onExport={onExport}
      exportDisabled={exportDisabled}
      className={className}
    />
  );
};
